/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name serverValidate
 * @description Binds an inputs form validation to a model state returned form the server
 * @attr {Object} server-modelstate Model state object to bind to
 * @attr {Object} server-validate Key in model state that represents this field. Defaults to the ngModel value.
 */
angular.module('mercury.directives.servervalidate', [])
.directive('serverValidate', function() {
  return {
    require: 'ngModel',
    link: function(scope, ele, attrs, ngModelCtrl) {
      scope.$watch(attrs.ngModel, function() {
        ngModelCtrl.$setValidity('server', true);
      });

      scope.$watch(attrs.serverModelstate || 'modelState', function(modelState) {
        if (!modelState) {
          return;
        }

        var modelStateKey = attrs.serverValidate || attrs.ngModel;
        if (modelState[modelStateKey]) {
          ngModelCtrl.$setValidity('server', false);
          ngModelCtrl.$error.server = modelState[modelStateKey];
        } else {
          ngModelCtrl.$setValidity('server', true);
        }
      });
    }
  };
});
